<script setup lang="ts">
import { ref, watchEffect } from 'vue';

import type { ITableCellFormatterProps } from './types';
import { useTableCellFormatter } from './composables';

const props = defineProps<ITableCellFormatterProps>();

const htmlValue = ref('');

const { updateValue } = useTableCellFormatter();

function updateHtmlValue(): void {
  htmlValue.value = updateValue(props.value, props.column, props.searchQuery, props.rowData);
}

watchEffect(() => updateHtmlValue());
</script>

<template>
  <span v-data-qa-auto-id="'VTableCellFormatter'"
    data-id="table-body-row-cell"
    class="text-editor"
    v-html="htmlValue"
  />
</template>
